import { privateRequest } from "../axios";

export interface OrganizationSettings {
  id: number;
  name: string;
  isActive: boolean;
  organizationProfileURL?: string;
  createdAt: string;
  modifiedAt: string;
  modifiedBy: number;
  createdBy: number;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

const getOrganizationSettings = async (): Promise<OrganizationSettings> => {
  const response = await privateRequest.get<ApiResponse<OrganizationSettings>>("/organizations/settings");
  return response.data.data;
};

const updateOrganizationSettings = async (formData: FormData): Promise<OrganizationSettings> => {
  const response = await privateRequest.put<ApiResponse<OrganizationSettings>>("/organizations/settings", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data.data;
};

const OrganizationService = {
  getOrganizationSettings,
  updateOrganizationSettings,
};

export default OrganizationService;
